import {
  Button,
  LinkHandler,
  IconQuestionMark,
  Typography,
} from '@/components/atoms';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import styled from 'styled-components';

interface IConnect {
  customerEmail: string;
  brandId: string;
  company: string;
}

const Container = styled.div`
  background-color: ${props => props.theme.paletteDefault.offWhite};
  padding: 24px 16px;
`;

const TextContainer = styled.div`
  margin-bottom: 16px;
`;

const ConnectCustomerWithBrand: React.FC<IConnect> = ({
  customerEmail,
  brandId,
  company,
}) => {
  const { t } = useTranslation('common');

  const router = useRouter();

  const url = `${process.env.NEXT_PUBLIC_AIRTABLE_ASK_DESIGNER_LINK}?prefill_Page=${router.asPath}&prefill_Email=${customerEmail}&prefill_Brand+ID=${brandId}&prefill_Company+Name=${company}&hide_Page=true&hide_Email=true&hide_Brand+ID=true&hide_Company+Name=true`;

  return (
    <Container>
      <TextContainer>
        <Typography datatype="caption">
          {t('common:cta.any-questions')}
        </Typography>
        <Typography datatype="caption_1">
          {t('common:cta.contatct-the-designer')}
        </Typography>
      </TextContainer>
      <Button
        variant={'outlined'}
        size="medium"
        startIcon={
          <IconQuestionMark
            width={16}
            height={18}
            style={{ position: 'relative', top: '2px' }}
          />
        }>
        <LinkHandler href={url}>
          <a target="_blank">{t('common:cta.ask-the-designer')}</a>
        </LinkHandler>
      </Button>
    </Container>
  );
};

export default ConnectCustomerWithBrand;
